import React from 'react';

interface BuyTicketButtonProps {
  eventId: string;
  currentUserId: string;
  onTicketPurchase: (eventId: string, userId: string, quantity: number) => void;
  quantity: number;
}

const BuyTicketButton: React.FC<BuyTicketButtonProps> = ({ eventId, currentUserId, onTicketPurchase, quantity }) => {
  const handleBuyClick = () => {
    onTicketPurchase(eventId, currentUserId, quantity);
  };

  return (
    <button
      onClick={handleBuyClick}
      className="px-3 py-2 rounded-lg bg-kala-secondary text-kala-900 hover:bg-cyan-400 transition-colors text-xs font-bold"
    >
      Buy Ticket
    </button>
  );
};

export default BuyTicketButton;
